import React from 'react';

interface SettingsHeaderProps {
  headerText: string;
  subText: string;
}

const SettingsHeader: React.FC<SettingsHeaderProps> = ({ headerText, subText }) => {
  return (
    <div className="h-24 bg-white border-b border-gray-300 flex flex-col justify-center pl-6 py-4">
      <h1 className="text-2xl font-semibold mb-2">{headerText}</h1>
      <p className="text-gray-600 text-xs leading-5">{subText}</p>
    </div>
  );
};

export default SettingsHeader;
